import Vue from 'vue'
import * as types from '../mutation'
import api from '@/api/activity'


const state = {
    doCard:{},
    medalWall:[],
    clockingToday:0, //今天是否打卡
    clockingTimes:0,  //已打卡次数
    patchTimes:0,  //可补卡次数
    sharePoster:'',  //分享海报图
    receiveStatus:false,  //保存领奖信息是否成功
    clockStatus:false,
    awardTips:'',
    clickMedalWall:{},
    clockPrizeType:0
}
const mutations = {
    [types.GET_DO_CARD_DATA](state, res) {
        if(!res.joinPeople){
            res.joinPeople = 0;
        }
        Vue.set(state, 'doCard', res);
    },
    [types.GET_DO_CARD_MY_DATA](state, res) {
        Vue.set(state, 'medalWall', res.medalWall);
        Vue.set(state, 'clockingTimes', res.clockingTimes);
        Vue.set(state, 'clockingToday', res.clockingToday);
        Vue.set(state, 'patchTimes', res.patchTimes);
    },
    [types.SAVE_PRIZE_TYPE](state, res) {
        Vue.set(state, 'clockPrizeType', res.prizeType);
    },
    [types.GET_SHARE_POSTER](state, res) {
        Vue.set(state, 'sharePoster', res.poster);
    },
    [types.CHANGE_RECEIVE_STATUS](state,data) {
        Vue.set(state, 'receiveStatus', data);
    },
    [types.CHANGE_CLOCK_STATUS](state,data) {
        Vue.set(state, 'clockStatus', data);
    },
    [types.GET_AWARD_TIPS](state,res) {
        Vue.set(state, 'awardTips', res.tips);
    },
    
}
const actions = {
    getDoCard( {commit} ,data){  //获取首页公共数据
        return api.getDoCard(data, (res) =>{
            commit(types.GET_DO_CARD_DATA,res);
        })
    },    
    getDoCardMyData( {commit} ,data){  //获取首页我的数据
        return api.getDoCardMyData(data, (res) =>{
            commit(types.GET_DO_CARD_MY_DATA,res);
        })
    },
    patchCard( {dispatch,commit} ,data){  //补卡
        return api.patchCard(data, (res) =>{
            commit(types.SAVE_PRIZE_TYPE,res)
            dispatch('getDoCardMyData',{});
            dispatch('getDoCard',{});
        })
    },
    clicking( {dispatch,commit} ,data){  //打卡
        return api.clicking(data, (res) =>{
            commit(types.SAVE_PRIZE_TYPE,res)
            dispatch('getDoCardMyData',{});
            dispatch('getDoCard',{});
        })
    },
    getSharePoster( {commit} ,data){  //获取分享图
        return api.getSharePoster(data, (res) =>{
            commit(types.GET_SHARE_POSTER,res);
        })
    },
    receivePrize( {dispatch,commit} ,data){  //领取奖品
        return api.receivePrize(data, (res) =>{
            commit(types.CHANGE_RECEIVE_STATUS,true)
            dispatch('getDoCardMyData',{});
            dispatch('getDoCard',{})
        })
    },
    getAwardTips( {commit} ,data){  //获取其他资料奖品提示语
        return api.getAwardTips(data, (res) =>{
            commit(types.GET_AWARD_TIPS,res);
        })
    },
}
const getters = {
    doCard: state => state.doCard,
    medalWall: state => state.medalWall,
    clockPrizeType: state => state.clockPrizeType,
    clockingTimes: state => state.clockingTimes,
    clockingToday: state => state.clockingToday,
    patchTimes: state => state.patchTimes,
    sharePoster: state => state.sharePoster,
    receiveStatus: state => state.receiveStatus,
    clockStatus: state => state.clockStatus,
    awardTips: state => state.awardTips,
    clickMedalWall: state => state.clickMedalWall,
}
  
  export default {
        namespaced: true,
        state,
        actions,
        getters,
        mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/activity.js